import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { useTheme } from '@techstyle/react-components';
import { defineMessages, useIntl } from '@techstyle/react-intl';
import { updateSessionDetail } from '@techstyle/redux-core';

import { toggleCartDrawer } from '../../actions/cart';
import {
  getItemCountExcludingMembership,
  getInfluencerItemCountExcludingMembership,
} from '../../utils/selectors';
import { RootState } from '../../utils/types';
import NewThemeIcon from '../NewThemeIcon/NewThemeIcon';

const StyledBagButton = styled.button`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  padding-right: 16px;
  justify-content: flex-end;

  > svg {
    height: 24px;
    width: 24px;
  }
`;

const StyledCount = styled.span`
  margin-left: 5px;
  ${props => props.theme.subHeader.variants.subHeading4Uppercase.textStyles}
  font-size: 12px;
  color: ${props => props.theme.colors.gunmetal};
`;

const messages = defineMessages({
  cartIconLabel: {
    defaultMessage: 'Cart',
    id: 'global_cta.cart_tt',
  },
});

function ShoppingBagNavMobile() {
  const intl = useIntl();
  const theme = useTheme(null, null);
  const dispatch = useDispatch();
  const cartItemCount = useSelector<RootState>(state =>
    state.customer.isInfluencer
      ? getInfluencerItemCountExcludingMembership(state)
      : getItemCountExcludingMembership(state)
  );
  const showCartDrawer = () => {
    dispatch(toggleCartDrawer(true, { fetchCart: true }));
    dispatch(updateSessionDetail({ name: 'sxf_minicart', value: '' }));
  };
  return (
    <StyledBagButton
      onClick={showCartDrawer}
      disabled={theme.context.checkout}
      aria-label={intl.formatMessage(messages.cartIconLabel)}
      data-autotag="nav-cart-button"
      data-qa-automation="homeShoppingBag"
    >
      <NewThemeIcon type="cart" />
      <StyledCount>{`(${cartItemCount})`}</StyledCount>
    </StyledBagButton>
  );
}

export default ShoppingBagNavMobile;
